import { faCalendar } from "@fortawesome/pro-solid-svg-icons"
import { Box, Divider, FormControlLabel, Grid, Switch, TextField, useTheme } from "@mui/material"
import Typography from "@mui/material/Typography"
import { CircleIcon } from "components/icons/CircleIcon"

import { useEffect } from "react"
import * as Yup from "yup"

const BplIntegrationSwitch = (props: any) => {
  const { values, setFieldValue, handleChange, handleBlur, errors, touched, setValidationStep, t } = props
  const theme = useTheme()

  useEffect(() => {
    const violationObj = {
      bplIntegrationActive: Yup.boolean(),
      bplUrl: Yup.string().when("bplIntegrationActive", {
        is: true,
        then: (schema) => schema.required(t("settings.companies.url_to_bpl_is_required", "Url to bpl is mandatory")),
        otherwise: (schema) => schema.nullable()
      })
    }
    setValidationStep(Yup.object().shape(violationObj))
  }, [values])

  return (
    <>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Grid item xs={2}>
          <CircleIcon icon={faCalendar}
            backgroundColor={(theme.palette as any).primary[300]}
            color={(theme.palette as any).primary[900]}
            size="sm"
            sx={{ marginRight: "15px" }} />
        </Grid>

        <Grid item xs={8}>
          <Typography variant="h5">{t("settings.form.bpl_integration", "BPL integration")}</Typography>
        </Grid>
        <Grid item xs={2}>
          <FormControlLabel
            label=""
            control={
              <Switch
                checked={values.bplIntegrationActive}
                onChange={(event) => {
                  if (values.bplIntegrationActive) {
                    setFieldValue("bplUrl", null)
                  }
                  setFieldValue("bplIntegrationActive", event.target.checked)
                }}
              />
            }
          />
        </Grid>
      </Grid>
      {values.bplIntegrationActive && (
        <Box marginTop={2}>
          <Divider />
          <Box marginY={2}>
            <Grid container direction="row" spacing={2} justifyContent="space-between" alignItems="center">
              <Grid item xs={12} lg={3}>
                <Typography variant="h5">{t("settings.companies.url_to_bpl", "URL to BPL")}</Typography>
              </Grid>
              <Grid item xs={12} lg={9} justifyContent="flex-end">
                <TextField
                  style={{ marginTop: 5 }}
                  autoComplete="on"
                  fullWidth
                  type="text"
                  id="bplUrl"
                  name="bplUrl"
                  placeholder="https://kund-bpl..."
                  value={values.bplUrl}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                  error={touched.bplUrl && errors.bplUrl ? true : false}
                  helperText={touched.bplUrl && errors.bplUrl ? errors.bplUrl : null}
                  size="small"
                />
              </Grid>
            </Grid>
          </Box>
          <Divider />
          <Box marginY={2}>
            <Grid container direction="row" spacing={2} justifyContent="space-between" alignItems="center">
              <Grid item xs={8} md={8}>
                <Typography variant="h5">{t("global.number_of_days", "Number of days")}</Typography>
                <Typography variant="bodyMedium">
                  {t("settings.form.number_of_days", "The number of days shows how far ahead drivers should see their assignments.")}
                </Typography>
              </Grid>
              <Grid item xs={4} md={4} justifyContent="flex-end">
                <TextField
                  autoComplete="off"
                  fullWidth
                  type="number"
                  id="bplDaysShown"
                  placeholder="1-200"
                  defaultValue={values.bplDaysShown ? values.bplDaysShown : 3}
                  value={values.bplDaysShown}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.bplDaysShown && errors.bplDaysShown ? true : false}
                  helperText={touched.bplDaysShown && errors.bplDaysShown ? errors.bplDaysShown : null}
                  variant="outlined"
                  size="small"
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
    </>
  )
}

export default BplIntegrationSwitch
